export enum StyleMusical {
    pasDeMusiqueId = "51",
}